export const siteDetails = {
  brandName: 'ADarveo',
  legalName: 'ADarveo',
  websiteUrl: 'https://adarveo.com',
  supportEmail: 'support@adarveo.com'
} as const;

export const appUrl = import.meta.env.VITE_APP_URL || 'https://app.adarveo.com';

